<template>
	<div id="home" class="mainPage">
		<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
		  <ol class="carousel-indicators">
		    <!-- <li data-target="#carousel-example-generic" data-slide-to="0" class="active" style="margin-right:15px;"></li>
		    <li data-target="#carousel-example-generic" data-slide-to="1" style="margin-right:15px;"></li>
			<li data-target="#carousel-example-generic" data-slide-to="2"></li> -->
		  </ol>

		  <!-- Wrapper for slides -->
		  <div class="carousel-inner" role="listbox">
			<div class="item active bannerPage1">
		      <img src="../assets/img/banner_new.jpg" alt="..." >
		      <div class="carousel-caption">
		      	<div class="container">
			        <h1>视频内容分析与处理</h1>
			        <p>高效、批量自动化处理视频水印、片头片尾 、广告</p>
					<p>实现视频处理日完成量1000+通过多维AI技术，对视频进行智能分析</p>
					<p>集关键帧识别、语音识别、视频OCR、泛标签提取等技术一体的智能视频处理</p>
		        </div>
		      </div>
		    </div>
		  </div>
		</div>
		<div class="vediobanner main">
			<div class="title" style="margin-bottom:50px">
				<h2>功能演示</h2>
				<p>
					<span>DEMONSTRATION</span>
				</p>
			</div>
			<div class="container vedioBox main" style="padding-top:0">
				<vediobar></vediobar>
			</div>
		</div>
		<div class="vedio" id="vedioBox" style="background-color:#fff">
			<div class="container vedioBox main">
				<div class="title" style="margin-bottom:50px">
					<h2>功能介绍</h2>
					<p>
						<span>FUNCTION</span>
					</p>
				</div>
				<div class="row serve" :style="serveBgx" style="margin:0" >
					<div class="col-md-6 col-xs-12" v-for="(item,index) in imgArg" style="background-color:rgba(0, 71, 103, 0.2)">
						<div class="itemsicon" >
							<div class='itemsimg'>
								<div class="dy">
									<img :src="require('../assets/img/'+item.icon+'.png')">
								</div>
								
							</div>
							<div class="itemstext">
								<p  style="font-weight:bold">{{item.title}}</p>
								<p style="margin:0">{{item.dec}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partner container main">
			<div class="title" style="margin-bottom:50px">
				<h2>免费试用</h2>
				<p>
					<span>ON TRIAL</span>
				</p>
			</div>
			<div class="partnerBox">
				 <div class="form">
					 <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  >
						 	<el-row :gutter="80">
								 <el-col :span="12">
									  <el-form-item label="姓名" prop="name">
											<el-input class="in_dy" v-model="ruleForm.name" placeholder="请输入您的姓名"></el-input>
									  </el-form-item>
								 </el-col>
								 <el-col :span="12">
									  <el-form-item label="电话" prop="telephone">
											<el-input class="in_dy" v-model="ruleForm.telephone" placeholder="请输入手机号" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
									  </el-form-item>
								 </el-col>
							 </el-row>
							 <el-row :gutter="80" style="margin-bottom:50px">
								 <el-col :span="12">
									  <el-form-item label="公司名" prop="company">
											<el-input class="in_dy" v-model="ruleForm.company" placeholder="请输入您的公司名"></el-input>
									  </el-form-item>
								 </el-col>
								 <el-col :span="12">
									  <el-form-item label="需求描述" prop="RequirDesc">
											<el-input class="in_dy" v-model="ruleForm.RequirDesc" placeholder="简单描述您的需求"></el-input>
									  </el-form-item>
								 </el-col>
							 </el-row>
							  <el-row>
								 <el-col :span="24">
									  <el-form-item>
											<el-button type="primary" @click="submitForm('ruleForm')" size='medium'>立即提交</el-button>
									  </el-form-item>
								 </el-col>
							 </el-row>
					 </el-form>	
				 </div>
			</div>
		</div>
		<el-dialog
			:visible.sync="showDialog"
			:show-close='false'
			width="600px"
			>
			<el-row>
				<el-col :span="24">
					<div style="display:flex;justify-content:center;align-items:center;">
						<i class="el-icon-circle-check" style="font-size:50px;color:#67C23A;margin-right:20px"></i>
						<span style="font-size:20px">提交成功，工作人员将在2个工作日内联系您</span>
					</div>
					
				</el-col>
			</el-row>
			 <span slot="footer" class="dialog-footer">

			</span>
		</el-dialog>
		<el-dialog
			:visible.sync="errorDialog"
			:show-close='false'
			width="600px"
			>
			<el-row>
				<el-col :span="24">
					<div style="display:flex;justify-content:center;align-items:center;">
						<i class="el-icon-circle-close" style="font-size:50px;color:#F56C6C;margin-right:20px"></i>
						<span style="font-size:20px">需求已提交,请耐心等待工作人员与您联系</span>
					</div>
					
				</el-col>
			</el-row>
			 <span slot="footer" class="dialog-footer">

			</span>
		</el-dialog>
	</div>
</template>
<style lang='scss' scoped>
	.itemsicon{
		display: flex;
		width: 90%;
		margin:30px;
		color: #fff;
		.itemsimg{
			width: 150px;
			.dy{
				width: 100px;
			}
		}
		.itemstext{
			width: calc(100% - 150px);
			font-size: 16px;
		}
	}
	.vediobanner{
		width: 100%;
		.content_vedio{
			width: 90%;
			margin: auto;
		}
	}
</style>
<script>
import vediobar from '@/components/base/vediobar.vue';
import axios from 'axios';
export default {
  name:'Home',
  components: { vediobar },
  data() {
    return {
	  serveBgx:{
	 	backgroundImage:'url(' + require('../assets/img/newbg01.png') + ')'
	  },
	  showDialog:false,
	  errorDialog:false,
      imgArg:[
        {
          title:'音视频分类',
          dec:'基于对视频语音及图像的综合分析,对视频内容理解后形成分类标签',
          icon:'001',
        },
		{
          title:'泛标签提取',
          dec:'基于自然语言处理,将识别结果进行多次校对和关键字提取,得到最精准的标签',
          icon:'002',
        },
		{
          title:'音视频语音识别',
          dec:'基于长语音识别技术,针对视频场景优化,精准识别视频中的语音内容',
          icon:'003',
        },
        {
          title:'智能拆条',
          dec:'通过智能识别算法对非结构化的视频数据进行特征分析,将连续的视频流划分为具有特定语义的片段',
          icon:'004',
        },
        {
          title:'视频OCR',
          dec:'更好的适配复杂背景，精准识别视频画面中包括字幕、标题、弹幕等关键内容',
          icon:'005',
        },
        {
          title:'水印识别及去除',
          dec:'水印随机位置识别,准确确定水印位置坐标,针对视频水印编写去除算法,对视频水印位置色彩高精度复原',
          icon:'006',
        },
      
      ],
      dialogVisible:false,
      dialogTitle:'',
      videoSrc:'v1',
	  ruleForm:{
		  name:'',//姓名
		  telephone:'',
		  company:'',
		  RequirDesc:''

	  },
	 rules: {
          name: [
            { required: true, message: '请输入您的姓名', trigger: 'blur' },
          ],
		  telephone:[
			{ required: true, message: '请输入手机号', trigger: 'blur' },
			{pattern: /^1[3-9]\d{9}$/,message: '手机号格式错误'}
		  ],
		  company:[
			  { required: true, message: '请输入您的公司名', trigger: 'blur' },
		  ],
		  RequirDesc:[
			  { required: true, message: '简单描述您的需求', trigger: 'blur' },
		  ]
    	}
    }
  },
  mounted() {

  },
  created() {

  },
  methods:{
    initVideo() {
      //初始化视频方法

      let videoDom = document.getElementById('myVideo'+this.videoSrc);
      this.myPlayer = null;
      this.myPlayer = this.$video(videoDom, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "800px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px"
      });
      this.myPlayer.play()
    },
    playVedio(index) {
    	this.dialogVisible = true;
    	this.dialogTitle = this.vedioAr[index].title;
    	this.videoSrc = this.vedioAr[index].videoSrc;
    	this.$nextTick(() => {
        this.initVideo();
      })
    },
    handleClose() {
    	this.myPlayer.pause();
    	this.dialogVisible = false;
    },
	submitForm(formName){
		var self=this;
		 this.$refs[formName].validate((valid) => {
          if (valid) {
			    let serviceUrl = process.env.VUE_APP_Domain+'/ISaveUserInfo';
				let params={
						name:this.ruleForm.name,
						phone:this.ruleForm.telephone,
						company:this.ruleForm.company,
						demand:this.ruleForm.RequirDesc
				}
				axios.get(serviceUrl, {  //params参数必写 , 如果没有参数传{}也可以
					params: params
				}).then(res=>{
					if(res.data=="save success!"){
						self.Success(formName);
					}else{
						self.error(formName)
					}
				})
			
          } else {
            console.log('error submit!!');
            return false;
          }
        });
	},
	Success(formName){
		var self=this;
		self.showDialog=true;
		var timer=null;
		clearTimeout(timer);
		timer=setTimeout(()=>{
			self.$refs[formName].resetFields();
			self.showDialog=false;
		},3000)
	},
	error(formName){
		var self=this;
		self.errorDialog=true;
		var timer=null;
		clearTimeout(timer);
		timer=setTimeout(()=>{
			self.$refs[formName].resetFields();
			self.errorDialog=false;
		},3000)
	}
  }
}
</script>

<style lang="scss">
.in_dy{
	.el-input__inner{
		height: 50px !important;
	}
}
.vjs-control-bar{
	margin-bottom: -30px;
	opacity:1!important;
}
#home{
	.vedio{
		position: relative;
		background-color: #fbfbfb;
		.vedioBox{
			// position: absolute;
	  //   top: -40px;
	  //   left: 50%;
	  //   transform: translateX(-50%);
	  h1{
	  	text-align: center;
	  	font-weight: bold;
	  	margin-bottom: 20px;
	  	color: $--bg-primary;
	  }
	  p.dec{
	  	text-align: center;
	  	margin-bottom: 30px;
	  	color: $--bg-primary;
	  	i{
	  		color: $--color-primary;
	  		padding:0 10px;
	  	}
	  }
	    .row{
	    	img{
	    		width: 100%;
	    	}
	    	>div{
	    		&:nth-child(4),&:nth-child(5),&:nth-child(6){
	    			.box{
	    				// background-color: $--color-primary;
	    			}
	    		}
	    	}
	    }
		}
		.box{
			background-color: #fff;
			padding:15px;
			margin-bottom: 30px;
			box-shadow: 0 0 5px #d8dfe3;
			position: relative;
			border-radius: 5px;
			&:hover{
				box-shadow: 0 0 10px #a0c7e0;
				.hover{
					display: block;
				}
			}
			.hover{
				position: absolute;
				top: 0;left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(153, 199, 229, 0.4);
				border-radius: 5px;
				display: none;
				cursor: pointer;
				i{
					position: absolute;
					top: 50%;
					left: 50%;
					transform:translate(-50%,-50%);
					font-size: 40px;
					color: #fff;
				}
			}
			i.typeIcon{
				font-size: 40px;
				color: $--color-primary;
			}
			.title{
				font-size: 20px;
				color: $--bg-primary;
			}
			.dec{
				font-size: 13px;
				color: #999;
			}
		}
		.vedioBoxItem{
			padding:0;
			background-color: #fff;
			margin-bottom: 30px;
			box-shadow: 0 0 5px #d8dfe3;
			position: relative;
			border-radius: 5px;
			overflow: hidden;
			p{
				padding: 10px;
				margin:0;
				font-weight: bold;
				font-size: 16px;
				color: $--bg-primary;
			}
			.hover{
				position: relative;
				cursor: pointer;
				img{
					width: 100%;
          filter: blur(3px);
				}
				.hoverBox{
					position: absolute;
					top: 0;left: 0;
					width: 100%;height: 100%;
					background-color: rgba(31,31,31,0.4);
					i{
						position: absolute;
						top: 50%;
						left: 50%;
						transform:translate(-50%,-50%);
						font-size: 40px;
						color: rgba(255,255,255,0.7);
						transition:all 0.5s;
						//transform-origin:50% 50%;
					}
				}
				&:hover{
					i{
						color: $--color-primary!important;
						transform:scale(1.1) translate(-50%,-50%);
					}
				}
			}
		}
	}

}
@media (max-width: 768px){
	#home{
		.banner{
			.left{
				padding-top: 0;
				.title{
					font-size: 20px;
				}
				.dec{
					padding:10px 0;
					font-size: 14px;
				}
				.btn{
					padding: 10px 40px;
				}
			}


		}
		.vedio{
			.vedioBox{
				width: 100%;
			}
		}
		.serve{
			.serveBox{
				p{
					span{
						padding:0 15px;
					}
				}
			}
		}
	}
}
</style>
